import { LOCATION_CHANGE } from "connected-react-router";
import { createMiddleware } from "redux-beacon";
import GoogleTagManagerImport from "@redux-beacon/google-tag-manager";

// `@redux-beacon/google-tag-manager` is a CommonJS module that sets `exports.default`.
// After the Vite 8 (Rolldown) upgrade its pre-bundled ESM wrapper does `export default require_dist()`,
// so the default import is the CJS `exports` object (`{ default: fn, __esModule: true }`) rather than
// the function itself. Unwrap the nested `.default` when present, keeping a fallback for other interop.
const GoogleTagManager = GoogleTagManagerImport.default || GoogleTagManagerImport;

import { LOGIN, LOGOUT_SUCCESS } from "shared-frontend/redux/actions/user";
import { LINK_SITE_SUCCESS } from "shared-frontend/redux/actions/sites";
import { SIGNUP_SUCCESS, ACTIVATE_SUCCESS } from "shared-frontend/redux/actions/signup";
import { RESET_PASSWORD_SUCCESS, SEND_RESET_PASSWORD_EMAIL_SUCCESS } from "shared-frontend/redux/actions/resetPassword";
import { CANCEL_SUBSCRIPTION_SUCCESS } from "shared-frontend/redux/actions/subscriptions";

export const SUBSCRIBE_NEWSLETTER_SUCCESS = "SUBSCRIBE_NEWSLETTER_SUCCESS";

/**
 * Create an event object to send to GoogleTagManager.
 *
 * @param {string} type The name of the action.
 * @param {Object} data Optional. The data object to associate to the action.
 *
 * @returns {Object} The event object to send to GoogleTagManager.
 */
const createEvent = ( type, data ) => ( {
	event: "redux_event",
	// eslint-disable-next-line camelcase
	redux_event_params: { type, data },
} );

export const eventsMap = {
	[ LOCATION_CHANGE ]:
		action => createEvent( "navigation", { page: action.payload.pathname } ),
	[ LOGIN ]:
		() => createEvent( "login" ),
	[ LOGOUT_SUCCESS ]:
		() => createEvent( "logout" ),
	[ SIGNUP_SUCCESS ]:
		() => createEvent( "signup" ),
	[ ACTIVATE_SUCCESS ]:
		() => createEvent( "activate" ),
	[ LINK_SITE_SUCCESS ]:
		action => createEvent( "add_site", { site: action.site.url, type: action.site.type } ),
	[ SUBSCRIBE_NEWSLETTER_SUCCESS ]:
		() => createEvent( "newsletter_signup" ),
	[ RESET_PASSWORD_SUCCESS ]:
		() => createEvent( "password_reset" ),
	[ SEND_RESET_PASSWORD_EMAIL_SUCCESS ]:
		() => createEvent( "request_password_reset" ),
	/*
	 * The name travels on the action, sourced from the subscription detail response the cancel modal
	 * already renders. It used to be looked up in the subscriptions entity map, which is no longer
	 * populated — and for an account large enough to matter never could be. A missing name still skips
	 * the event rather than reporting an undefined one.
	 */
	[ CANCEL_SUBSCRIPTION_SUCCESS ]:
		( action ) => {
			if ( ! action.subscriptionName ) {
				return null;
			}

			return createEvent( "cancel_subscription", { subscription: action.subscriptionName } );
		},
};

// eslint-disable-next-line new-cap
export default createMiddleware( eventsMap, GoogleTagManager() );
